/* Source: src/mt-includes/js/src/core/animation/init.js*/
angular.module('website.core.animation', []);